/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * converts enum to object
 */
export const enumToObject = (enumObj: any) => {
  const result: { [key: string]: string } = {}

  for (const key in enumObj) {
    // eslint-disable-next-line no-prototype-builtins
    if (enumObj.hasOwnProperty(key)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      result[key] = enumObj[key]
    }
  }

  return result
}

interface DropdownOption {
  label: string
  value: number
}
/**
 * converts enum to array
 */
export function enumToArray<T>(enumObj: any): {
  keys: (keyof T)[]
  values: T[keyof T][]
} {
  const keys = Object.keys(enumObj).filter((key) =>
    Number.isNaN(Number(key))
  ) as (keyof T)[]
  const values = Object.values(enumObj).filter(
    (value) => typeof value === 'number'
  ) as T[keyof T][]
  return { keys, values }
}

/**
 * converts enum to dropdown options
 */
export const enumToDrpOpts = (
  enumObj: Record<string, string>
): { label: string; key: string }[] => {
  let count = 1
  return Object.values(enumObj).map((key) => ({
    label: key,

    key: (count++).toString()
  }))
}

/**
 * converts object to level select options
 */
export function objToLevSelOpts(inputObj: Record<number, string>) {
  return Object.entries(inputObj).map(([key, value]) => ({
    label: value,
    key: parseInt(key, 10) // Convert key to number if needed
  }))
}

/**
 * converts enum to select options
 */
export const enumToSelOpts = (
  enumObj: Record<string, string>
): { label: string; value: string }[] => {
  return Object.keys(enumObj).map((key) => ({
    label: enumObj[key],
    value: key
  }))
}

/**
 * converts object to select options
 */
export const objToSelOpts = (inputObj: any) => {
  return Object.entries(inputObj).map(([key, value]) => ({
    label: value as string,
    value: parseInt(key, 10)
  }))
}

const MAX_DROPDOWN_OPTIONS = 12

export const convertEnumToDropdownOptions = (
  enumObj: any
): DropdownOption[] => {
  const rgx = /(?=[A-Z0-9])/g
  const entry = Object.keys(enumObj)
    .filter((key) => Number.isNaN(Number(key))) // Filter out numeric keys added by TypeScript
    .filter((item) => item !== 'Null') // Filter out null value
    .slice(0, MAX_DROPDOWN_OPTIONS) // Take only first 12 value
  return entry.map((key) => ({
    label: key.split(rgx).join(' '),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    value: enumObj[key]
  }))
}
export const getEnumStringKeys = (enumObj: any): string[] => {
  return Object.keys(enumObj)
    .filter((key) => Number.isNaN(Number(key))) // Filter out numeric keys added by TypeScript
    .map((key) => key) // Get only the string keys
}
